
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rsldashboard/db-settings",
      function () {
        return require("private-next-pages/rsldashboard/db-settings/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rsldashboard/db-settings"])
      });
    }
  